<mat-dialog-content> <div class="mat-typrography">{{ message }}</div> </mat-dialog-content>
<mat-dialog-actions align="end">
	<button
		(click)="saveAndLeave()"
		color="primary"
		mat-raised-button
	>
		{{ 'utils.discard-change.ok-save' | translate }}
	</button>
	<button
		(click)="discard()"
		color="primary"
		mat-raised-button
	>
		{{ strings.confirm || 'utils.discard-change.ok' | translate }}
	</button>
	<button
		(click)="stay()"
		mat-button
	>
		{{ strings.cancel || 'utils.discard-change.cancel' | translate }}
	</button>
</mat-dialog-actions>
